module.exports = __webpack_public_path__ + "static/8base-logo-a895be2759e819b5b14d177054fefbff.png";